module.exports = __webpack_public_path__ + "img/Sarah_Kim.720772bf.png";